import { BadgeStatus } from 'vcp-common-ui-lib';
import { translate } from '@jsverse/transloco';

export enum TaskStatus {
    PENDING = 'PENDING',
    IN_PROGRESS = 'IN_PROGRESS',
    SUBMITTED = 'SUBMITTED',
    IN_REVIEW = 'IN_REVIEW',
    REJECTED = 'REJECTED',
    COMPLETE = 'COMPLETE',
}

export class TaskStatusHelper {
    static getTaskStatusString(status: TaskStatus): string {
        switch (status) {
            case TaskStatus.PENDING:
                return translate('CORE.TASK_STATUSES.PENDING');
            case TaskStatus.IN_PROGRESS:
                return translate('CORE.TASK_STATUSES.IN_PROGRESS');
            case TaskStatus.SUBMITTED:
                return translate('CORE.TASK_STATUSES.SUBMITTED');
            case TaskStatus.IN_REVIEW:
                return translate('CORE.TASK_STATUSES.IN_REVIEW');
            case TaskStatus.REJECTED:
                return translate('CORE.TASK_STATUSES.REJECTED');
            case TaskStatus.COMPLETE:
                return translate('CORE.TASK_STATUSES.COMPLETE');
            default:
                return '';
        }
    }

    static getTaskBadgeStatus(status: TaskStatus): BadgeStatus {
        switch (status) {
            case TaskStatus.PENDING:
                return 'neutral';
            case TaskStatus.IN_PROGRESS:
                return 'info';
            case TaskStatus.SUBMITTED:
                return 'warning';
            case TaskStatus.IN_REVIEW:
                return 'info';
            case TaskStatus.REJECTED:
                return 'error';
            case TaskStatus.COMPLETE:
                return 'success';
            default:
                return 'neutral';
        }
    }

    static getTaskStatusIcon(status: TaskStatus): string {
        switch (status) {
            case TaskStatus.PENDING:
                return 'remove_circle_outline';
            case TaskStatus.IN_PROGRESS:
                return 'play_circle_outline';
            case TaskStatus.SUBMITTED:
            case TaskStatus.IN_REVIEW:
                return 'assignment_returned';
            case TaskStatus.REJECTED:
                return 'assignment_late';
            case TaskStatus.COMPLETE:
                return 'check_circle';
            default:
                return '';
        }
    }
}
